// extracted by css-extract-rspack-plugin
export default {"cardContent":"card-content--Qp4vvKHEJCgp1ksx"};